import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import {
  faPhone,
  faMapMarkerAlt,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import "../assets/css/navigation/top-nav.css";

const topNav = () => {
  return (
    <div className="container">
      <div className="contents contacts">
        <div className="contact-info">
          <div className="location">
            <a
              href="https://maps.app.goo.gl/FBBXiWVABieRgbcaA"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faMapMarkerAlt} />
              <span>43155 E 45th Street, Shawnee, OK 74804</span>
            </a>
          </div>
          <div className="email">
            <a href="mailto:info@staffingok.com">
              <FontAwesomeIcon icon={faEnvelope} />
              <span>info@staffingok.com</span>
            </a>
          </div>
          <div className="phone">
            <a href="tel:4053674422">
              <FontAwesomeIcon icon={faPhone} />
              <span>405.367.4422</span>
            </a>
          </div>
        </div>
        <div className="social-media">
          <a href="https://www.facebook.com/p/Cohesive-Staffing-Solutions-100057638200275/?_rdr" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faFacebook} />
          </a>
          <a href="https://www.linkedin.com/company/cohesive-staffing/" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faLinkedinIn} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default topNav;
